import React from 'react'

import { Portlet } from '_zari/core'

import { IdGen } from 'utils'

import MainForm from './mainForm'

const NuevaCobranza = () => {
  const [_mainFormKey, setMainFormKey] = React.useState(IdGen.newId())

  const portletBreadcrumbs = React.useMemo(() => {
    return [
      {
        name: 'Cobranzas'
      }
    ]
  }, [])

  const resetMainForm = React.useCallback(() => {
    setMainFormKey(IdGen.newId())
  }, [])

  return (
    <Portlet>
      <Portlet.Header title='Cobranzas' breadcrumbs={portletBreadcrumbs} />
      <Portlet.Body>
        <MainForm key={_mainFormKey} resetMainForm={resetMainForm} />
      </Portlet.Body>
    </Portlet>
  )
}

export default React.memo(NuevaCobranza)
